<template>
  <!-- étoile CTA en currentColor : suit la couleur du texte du bouton (hover compris) -->
  <svg
    class="btn-star"
    viewBox="0 0 21 21"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g fill="currentColor">
      <rect x="9.9" width="1.2" height="9.3" />
      <rect x="9.9" y="11.7" width="1.2" height="9.3" />
      <rect x="1.9" y="14.5" width="8" height="1.2" transform="translate(-8.9 8.6) rotate(-45)" />
      <rect x="5.3" y="1.9" width="1.2" height="8" transform="translate(-2.5 5.9) rotate(-45)" />
      <rect x="11.1" y="5.3" width="7.9" height="1.2" transform="translate(.2 12.4) rotate(-45)" />
      <rect x="14.5" y="11.1" width="1.2" height="7.9" transform="translate(-6.3 15.1) rotate(-45)" />
      <rect x="11.6" y="9.9" width="9.3" height="1.2" />
      <rect y="9.9" width="9.3" height="1.2" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BtnStar'
}
</script>
